import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { bg } from './translations/bg';
import { en } from './translations/en';

i18n
  // Chain modules
  .use(initReactI18next)
  .init({
    lng: 'bg',
    fallbackLng: 'bg',
    debug: process.env.NODE_ENV === 'development',

    // React already does escaping
    interpolation: {
      escapeValue: false,
    },
    react: { wait: true },
    resources: {
      // 'translation' is the default namespace, simply use this one.
      bg: { translation: bg },
      en: { translation: en },
    },
  });

export default i18n;
